import { Link } from "react-router-dom";
import { Mail, Phone, Github, Twitter } from "lucide-react";
import XionLogo from "./XionLogo";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-[#06060C] mt-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <XionLogo size={32} />
              <span className="font-display font-black text-2xl tracking-tighter text-white">
                XION LABS
              </span>
            </div>
            <p className="text-slate-400 max-w-md leading-relaxed">
              A design & engineering studio founded and operated by{" "}
              <span className="text-white">Vedant Baligar</span>. Custom presentations, software,
              AI agents, 3D models, animated websites, and cinematic videos for ambitious brands.
            </p>
          </div>
          <div>
            <p className="font-mono uppercase text-xs tracking-[0.2em] text-[#00D4FF] mb-4">Studio</p>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/services" className="hover:text-white">Services</Link></li>
              <li><Link to="/portfolio" className="hover:text-white">Work</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link to="/reviews" className="hover:text-white">Reviews</Link></li>
              <li><Link to="/quote" className="hover:text-white">Request Quote</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono uppercase text-xs tracking-[0.2em] text-[#00D4FF] mb-4">Connect</p>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> <a href="mailto:baligarvedant@gmail.com" className="hover:text-white">baligarvedant@gmail.com</a></li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> <a href="tel:+919902155712" className="hover:text-white font-mono">+91 99021 55712</a></li>
              <li className="flex items-center gap-3 pt-1">
                <a href="#" className="hover:text-[#00D4FF]" aria-label="Twitter"><Twitter className="w-4 h-4" /></a>
                <a href="#" className="hover:text-[#00D4FF]" aria-label="GitHub"><Github className="w-4 h-4" /></a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row gap-3 items-center justify-between text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Xion Labs · Founded & operated by Vedant Baligar.</p>
          <p className="font-mono uppercase tracking-[0.2em]">v1.1 · cyan-protocol</p>
        </div>
      </div>
    </footer>
  );
}
